import { Action } from "../../action";
import { Cursor } from "../../cursor";
import { MarshalParameters } from "../../marshal";
import { RegisterValue } from "../../register";

type unaryOperator = (key: RegisterValue) => boolean
type binaryOperator = (lhs: RegisterValue, rhs: RegisterValue) => boolean

const unary: { [key: string]: unaryOperator } = {
    boolean: (key) =>
    {
        return Boolean(key);
    },
    not: (key) =>
    {
        return !key;
    }
};
const binary: { [key: string]: binaryOperator } = {
    and: (lhs, rhs) =>
        Boolean(lhs) && Boolean(rhs),
    or: (lhs, rhs) =>
        Boolean(lhs) && Boolean(rhs),
    equals: (lhs, rhs) =>
    {
        return lhs === rhs;
    },
    greater: (lhs, rhs) =>
    {
        return lhs > rhs;
    },
    greaterEqual: (lhs, rhs) =>
    {
        return lhs >= rhs;
    },
    less: (lhs, rhs) =>
    {
        return lhs < rhs;
    },
    lessEqual: (lhs, rhs) =>
    {
        return lhs <= rhs;
    },
    notEquals: (lhs, rhs) =>
    {
        return lhs !== rhs;
    },
}

export class Test extends Action
{
    public terminating = () => true;

    constructor()
    {
        super({
            description: "Run a test on the registers and if it resolves true send the" +
                "trigger event to the state machine. Note that the first test action to return true stops further" +
                "execution of actions in the state.",
            parameters: {
                lhs: {
                    description: "The left hand side of a binary operator",
                    type: "number"
                },
                rhs: {
                    description: "The right hand side of a binary operator",
                    type: "number"
                },
                value: {
                    description: "The test value of a unary operator",
                    type: "any"
                },
                operator: {
                    description: "The test operation to run",
                    type: [...Object.keys(unary), ...Object.keys(binary)]
                },
                trigger: {
                    description: "The trigger to send if the operator resolves true",
                    type: "string"
                }
            }
        });
    }
    public Resolve(cursor: Cursor, parameters: MarshalParameters): boolean
    {
        const operator = parameters.operator.value(cursor) as string;
        let test = false;

        if (unary[operator] !== undefined)
        {
            test = unary[operator](parameters.value.value(cursor));
        }
        else if (binary[operator] !== undefined)
        {
            test = binary[operator](parameters.lhs.value(cursor), parameters.rhs.value(cursor))
        }
        if (test)
        {
            const trigger = parameters.trigger.value(cursor) as string;
            cursor.trigger(trigger);
        }
        return test;
    }
}
